import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { RFBatteryIndicator } from './battery';
import { RFSignalIndicator } from './signal';
import { getStrForBatteryVoltage } from 'console/tabs/legacy/rf/rf-utils';
export const RFIndicators = memo(function RFIndicators(props) {
    const { rf, show_values, active, show_battery_value = true, flexDirection = 'row', } = props;
    if (rf == null) {
        return null;
    }
    const { palette } = useTheme();
    const { dbm, is_433, bat_v, bat, type } = rf;
    return (_jsxs(Box, { display: "flex", 
        //@ts-ignore
        flexDirection: flexDirection, alignItems: "center", columnGap: 0.5, rowGap: 0.5, color: active ? palette.error.contrastText : palette.action.active, children: [(dbm != null || is_433) && (_jsxs(Box, { display: "flex", alignItems: "center", columnGap: 0.5, children: [_jsx(RFSignalIndicator, { ...rf }), show_values && (_jsx(Typography, { variant: "body1", color: "testSecondary", children: is_433 ? '433 МГЦ' : `${dbm} дБм` }))] })), (bat != null || bat_v != null) && (_jsxs(Box, { display: "flex", alignItems: "center", columnGap: 0.5, children: [_jsx(RFBatteryIndicator, { ...rf }), show_values && show_battery_value && bat_v != null && (_jsx(Typography, { variant: "body1", color: "testSecondary", children: getStrForBatteryVoltage(bat, bat_v, type) }))] }))] }));
});
